/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

/** Utilities */
import formatDate from "../../../../../../../lib/formatDate";
import { DropdownWrapper } from "../../../../../../../components/ui/dropdownwrapper/DropdownWrapper";

/** Common Components */
import Avatar from "../../../../../../../components/ui/avatar/Avtar";
import Iconify from "../../../../../../../layouts/components/iconify/iconify";
import CardSection from "../../../../../../../components/ui/card/CardSection";
import IconButton from "../../../../../../../components/ui/iconbutton/IconButton";
import CenterModel from "../../../../../../../components/ui/centerModel/CenterModel";

/** Common Services & Data Files */
import SwalAlert from "../../../../../../../services/swalService/SwalService";
import ToastService from "../../../../../../../services/toastService/ToastService";

/** RTK Query */
import {
  useAddSynergyCommentMutation,
  useDeleteSynergyCommentMutation,
  useLazyGetAllSynergyCommentBySynergyIdQuery,
} from "../../../../../../../app/services/projectSynergyAPI";

/** CSS Files */
import "./SynergyComments.scss";

/** Lazily Loaded Components */
import EditSynergyComment from "./editSynergyComment/EditSynergyComment";
import CKEditorComponent from "../../../../../../../components/finalForms/ui/inputs/ckEditor/CKEditor";
import { editorConfig } from "../../../../../../../components/finalForms/ui/inputs/ckEditor/CkEditorConfig";


const SynergyComments = ({ synergyId }) => {

  const { user } = useSelector((state) => state.auth);
  const userID = user.userId;
  const UserName = user.userName;

  const [showModal, setShowModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [commentText, setCommentText] = useState("");

  const [comments, setComments] = useState([]);
  const [commentId, setCommentId] = useState();

  const { error } = SwalAlert();
  const { confirm } = SwalAlert();

  const toggleMessageBox = () => {
    setIsOpen(!isOpen);
    setCommentText("");
  };
  // API Calls
  const [
    getAllSynergyCommentBySynergyId,
    {
      isFetching: isgetAllSynergyCommentBySynergyIdFetching,
      isSuccess: isgetAllSynergyCommentBySynergyIdFetched,
      data: getAllSynergyCommentBySynergyIdData,
    },
  ] = useLazyGetAllSynergyCommentBySynergyIdQuery();

  const [addSynergyComment, {
    isSuccess: isSuccessaddSynergyComment,
    data: addSynergyCommentData,
  },] = useAddSynergyCommentMutation();

  const [deleteSynergyComment, {
    isSuccess: isDeleteSuccess,
    data: isDeletData
  },] = useDeleteSynergyCommentMutation();


  useEffect(() => {
    if (synergyId) {
      getAllSynergyCommentBySynergyId(synergyId);
    }
  }, [synergyId]);

  useEffect(() => {
    if (
      !isgetAllSynergyCommentBySynergyIdFetching &&
      isgetAllSynergyCommentBySynergyIdFetched &&
      getAllSynergyCommentBySynergyIdData
    ) {
      setComments(getAllSynergyCommentBySynergyIdData);
    }
  }, [
    isgetAllSynergyCommentBySynergyIdFetching,
    isgetAllSynergyCommentBySynergyIdFetched,
    getAllSynergyCommentBySynergyIdData,
  ]);

  useEffect(() => {
    if (isDeleteSuccess && isDeletData) {
      ToastService.success(isDeletData.errorMessage);
      getAllSynergyCommentBySynergyId(synergyId);
    }
  }, [isDeleteSuccess, isDeletData]);

  const handleCKEditorChange = (newData) => {
    setCommentText(newData);
  };

  const onEditAction = (comment) => {
    setCommentId(comment);
    setShowModal(true);
  };

  const AddCommentText = () => {
    const request = {
      userId: userID,
      commentText: commentText,
      synergyId: synergyId,
    };
    if (request.commentText === "") {
      error("please enter your comment", "Validation Failed!");
    } else {
      addSynergyComment(request);
    }
  };

  const closePopup = () => {
    setShowModal(false);
  };

  const onSuccessPopup = () => {
    setShowModal(false);
    getAllSynergyCommentBySynergyId(synergyId);
  };

  useEffect(() => {
    if (isSuccessaddSynergyComment && addSynergyCommentData) {
      if (addSynergyCommentData.errorMessage) {
        if (addSynergyCommentData.errorMessage.includes("exists")) {
          ToastService.warning(addSynergyCommentData.errorMessage);
          return;
        } else {
          ToastService.success(addSynergyCommentData.errorMessage);
          getAllSynergyCommentBySynergyId(synergyId);
          toggleMessageBox();
        }
      }
    }
  }, [isSuccessaddSynergyComment, addSynergyCommentData]);

  const handleDeleteClick = (comment) => {
    if (comment.userId !== userID) {
      ToastService.error("You can only delete your own comments.");
      return;
    }
    confirm(
      "Delete?",
      "Are you sure you want to delete this Synergy Comment?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        deleteSynergyComment(comment.commentID);
      }
    });
  };

  return (
    <div className="synergy-comments">
      <CardSection cardTitle="Comments"
        isContentLoading={isgetAllSynergyCommentBySynergyIdFetching}
      >
        <div className="synergy-comment-section">
          <div className={`synergy-comment-body ${isOpen ? "collapse" : ""}`}>
            {comments.map((comment) => (
              <div
                key={comment.commentID}
                // className={`synergy-comment-message ${comment.type}-message`}
                className={`synergy-comment-message ${comment.userId === userID ? 'outgoing-message' : ''}`}
              >
                <div className="synergy-comment-avatar">
                  <Avatar alt={comment.fullName} shape="circle" size="medium" />
                </div>
                <div className="synergy-comment-content">
                  <div className="synergy-comment-edit-sec">
                    {comment?.commentText && (
                      <div
                        className="synergy-comment-message"
                        dangerouslySetInnerHTML={{
                          __html: String(comment.commentText),
                        }}
                      ></div>
                    )}
                    <div className="synergy-comment-details">
                      <div className="synergy-comment-username">
                        {comment.fullName}
                      </div>
                      <div className="synergy-comment-time">
                        {formatDate(comment.commentDate, "DD/MM/YYYY HH:MM")}
                      </div>
                    </div>
                  </div>
                  {comment.userId === userID ? (
                    <div className="address-actions">
                      <DropdownWrapper
                        direction="left"
                        className="action-button-dropdown"
                        toggleElement={
                          <button className="customer-more-btn">
                            <Iconify icon="humbleicons:dots-horizontal" />
                          </button>
                        }
                      >
                        <button onClick={() => onEditAction(comment)}>
                          <Iconify icon="line-md:pencil" />
                          Edit
                        </button>
                        <button onClick={() => handleDeleteClick(comment)}>
                          <Iconify icon="material-symbols:close-rounded" />
                          Remove
                        </button>
                      </DropdownWrapper>
                    </div>
                  ) : null}
                </div>
              </div>
            ))}
          </div>

          {/* Floating Message Button */}
          <IconButton
            variant="contained"
            icon={isOpen ? "mdi:close" : "tabler:message"}
            shape="circle"
            className={isOpen ? "floating-message-btn" : "floating-message-btn-bottom"}
            size="medium"
            onClick={toggleMessageBox}
          />

          {/* Comment Box with Sliding Animation */}
          <div className={`synergy-comment-messagebox ${isOpen ? "open" : ""}`}>
            <div className="synergy-comment-avatar">
              <Avatar alt={UserName} shape="circle" size="medium" />
            </div>

            <CKEditorComponent
             data={commentText}
             isdisable={false}
             onCKEditorChange={handleCKEditorChange}
             config={{
              ...editorConfig,
              placeholder: "Please Enter Your comments",
             }}
             inputInfoConfig={{
              isInfoIcon: true,
              iconName: "info-circle",
              message: "This is a rich text editor.",
             }}
             />
            <div className="form-btn d-flex justify-content-end">
              <IconButton
                variant="contained"
                icon="fluent:send-16-filled"
                shape="square"
                className="theme-btn"
                size={"small"}
                onClick={AddCommentText}
              />
            </div>
          </div>
        </div>
      </CardSection>

      <div>
        {showModal && (
          <CenterModel
            showModal={showModal}
            handleToggleModal={closePopup}
            modalTitle="Edit your Comment"
            modelSizeClass="w-40"
          >
            <div className="row">
              <EditSynergyComment
                commentId={commentId}
                onClose={closePopup}
                onSuccessPopup={onSuccessPopup}
              />
            </div>
          </CenterModel>
        )}
      </div>
    </div>
  );
};

export default SynergyComments;
